import { render } from "./change-sort.vue?vue&type=template&id=172702c8&scoped=true&ts=true"
import script from "./change-sort.vue?vue&type=script&lang=tsx"
export * from "./change-sort.vue?vue&type=script&lang=tsx"

import "./change-sort.vue?vue&type=style&index=0&id=172702c8&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-172702c8"]])

export default __exports__